<ul class="nav">
  <li class="nav-item">
    <a
      class="nav-link"
      routerLink="/posts"
      routerLinkActive="active text-dark"
      [routerLinkActiveOptions]="{ exact: true }"
      >Posts</a
    >
  </li>
  <li class="nav-item">
    <a
      class="nav-link"
      routerLink="/admin/posts"
      routerLinkActive="active text-dark"
      >Admin</a
    >
  </li>
</ul>

<router-outlet></router-outlet>
